<template>
    <Tabs class="content" :tabsConfig="tabsConfig" @tabClick="tabClick">
        <component :is="currentComponent" :pageType="pageType" />
    </Tabs>
</template>

<script>
import PraiseList from "./PraiseList.vue";
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import AskAnswerLogPage from "@/views/zhiji/pages/robotDialogLog/AskAnswerLogPage";

export default {
    components: {
        PraiseList,
        AskAnswerLogPage,
        Tabs,
    },
    data() {
        return {
            currentComponent: "PraiseList",
            pageType: "likeLog",
        }
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.likedisplay.praiseList"),
                    contentName: "PraiseList"
                },
                {
                    tabName: this.$t("zhiji.likedisplay.praiseLog"),
                    contentName: "AskAnswerLogPage"
                }
            ];
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponent = data.componentName;
        }
    }
}
</script>
